/* =========================================================
   Sports n deco — Moteur "affiche TENNIS" (navigateur)
   Court dessiné (surface au choix) + score + joueurs + stats.
   Original à notre identité — PAS de copie d'UI/marque tierce.
   API : SNTennis.render(data, opts) -> string SVG
     data : { tournament, winner, opponent, date, score, venue, stats:[{val,lab}…4] }
     opts : { palette, surface:'terre'|'gazon'|'dur' }
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 60;

  // 8 couleurs (fond + texte) — alignées sur le moteur trophée
  const PALETTES = {
    blanc:   { label:'Blanc',        bg:'#ffffff', ink:'#0B2D5B', muted:'#8891a0', accent:'#FF6B2C', line:'#e6eaee' },
    mono:    { label:'Noir & blanc', bg:'#ffffff', ink:'#111111', muted:'#8a8a8a', accent:'#111111', line:'#e2e2e2' },
    nuit:    { label:'Nuit',         bg:'#0B2D5B', ink:'#ffffff', muted:'#9fb2ce', accent:'#FF6B2C', line:'#1c4577' },
    encre:   { label:'Encre',        bg:'#0E0E10', ink:'#ffffff', muted:'#8a8a90', accent:'#FF6B2C', line:'#2a2a2e' },
    kraft:   { label:'Kraft',        bg:'#efe7d6', ink:'#3A2C12', muted:'#8a7a58', accent:'#c2410c', line:'#d2c6a8' },
    sauge:   { label:'Sauge',        bg:'#e9f0eb', ink:'#24402F', muted:'#6f8a79', accent:'#2f7d54', line:'#c3d4c8' },
    ardoise: { label:'Ardoise',      bg:'#26303a', ink:'#f2f5f7', muted:'#9fb0bd', accent:'#e8b04b', line:'#3b4855' },
    bordeaux:{ label:'Bordeaux',     bg:'#f4ede7', ink:'#45131c', muted:'#9a7f70', accent:'#9c2233', line:'#dccabd' },
  };
  // 3 surfaces (couleur du terrain — indépendante de la palette)
  const SURFACES = {
    terre: { label:'Terre battue', base:'#c15b3c', line:'#f4ece3' },
    gazon: { label:'Gazon',        base:'#3f7a44', line:'#ffffff' },
    dur:   { label:'Dur',          base:'#2f6fa8', line:'#ffffff' },
  };

  function hx(x){ return x.replace('#',''); }
  function mix(a, b, t){ const A=hx(a),B=hx(b);
    const c=i=>Math.round(parseInt(A.substr(i,2),16)+(parseInt(B.substr(i,2),16)-parseInt(A.substr(i,2),16))*t).toString(16).padStart(2,'0');
    return '#'+c(0)+c(2)+c(4); }
  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  function T(x,y,txt,size,weight,fill,anchor,ls){
    return `<text x="${x}" y="${y}" font-size="${size}" font-weight="${weight}" fill="${fill}" text-anchor="${anchor||'middle'}"${ls?` letter-spacing="${ls}"`:''}>${esc(txt)}</text>`;
  }

  // Court de tennis (doubles) vu de dessus, proportions réelles 36×78, dans [x,y,w,h].
  function court(x, y, w, h, s, ink, accent){
    const sx = mx => x + (mx/36)*w, sy = my => y + (my/78)*h;
    const lw = (w*0.011).toFixed(2), fine = (w*0.008).toFixed(2);
    const L = (x1,y1,x2,y2,sw)=>`<line x1="${sx(x1).toFixed(1)}" y1="${sy(y1).toFixed(1)}" x2="${sx(x2).toFixed(1)}" y2="${sy(y2).toFixed(1)}" stroke="${s.line}" stroke-width="${sw||lw}"/>`;
    let o = '';
    o += `<rect x="${sx(0).toFixed(1)}" y="${sy(0).toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" fill="${s.base}" rx="2"/>`;
    o += `<rect x="${sx(4.5).toFixed(1)}" y="${sy(0).toFixed(1)}" width="${((27/36)*w).toFixed(1)}" height="${h.toFixed(1)}" fill="${mix(s.base,'#ffffff',0.06)}"/>`;
    o += `<rect x="${sx(0).toFixed(1)}" y="${sy(0).toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" fill="none" stroke="${s.line}" stroke-width="${lw}"/>`;
    o += L(4.5,0,4.5,78) + L(31.5,0,31.5,78);          // couloirs simples
    o += L(4.5,18,31.5,18) + L(4.5,60,31.5,60);        // lignes de service
    o += L(18,18,18,60);                                // médiane de service
    o += L(0,39,36,39, (w*0.02).toFixed(2));            // filet
    o += L(18,0,18,3.5,fine) + L(18,74.5,18,78,fine);   // marques centrales
    o += `<circle cx="${sx(18).toFixed(1)}" cy="${sy(6).toFixed(1)}" r="${(w*0.028).toFixed(1)}" fill="${ink}" opacity="0.85"/>`;
    o += `<circle cx="${sx(18).toFixed(1)}" cy="${sy(72).toFixed(1)}" r="${(w*0.028).toFixed(1)}" fill="${accent}"/>`;
    return o;
  }

  function render(data, opts){
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.nuit;
    const s = SURFACES[opts.surface] || SURFACES.terre;
    const gold = p.accent;
    const cx = PW/2;
    const CH = 520, CW = CH*36/78, cX = cx-CW/2, cY = 250;
    const stats = (data.stats || []).slice(0,4);
    const cols = stats.map((_,i)=> MX + (PW-2*MX)*(i+0.5)/(stats.length||1));
    const subtitle = data.opponent ? `def. ${data.opponent}${data.date?' · '+data.date:''}` : (data.date||'');

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<rect x="18" y="18" width="${PW-36}" height="${PH-36}" fill="none" stroke="${p.line}" stroke-width="1.5" rx="3"/>
${T(cx,116,(data.tournament||'').toUpperCase(),19,700,p.accent,'middle',6)}
${T(cx,180,(data.winner||'VOTRE NOM').toUpperCase(),44,800,p.ink,'middle',-0.5)}
${subtitle ? T(cx,214,subtitle,15,600,p.muted,'middle',1) : ''}
${court(cX,cY,CW,CH,s,p.ink,gold)}
${data.opponent ? T(cX-14,cY+(6/78)*CH+5,(data.opponent||'').toUpperCase(),12,700,p.muted,'end',1) : ''}
${T(cX+CW+14,cY+(72/78)*CH+5,(data.winner||'VOUS').toUpperCase(),12,700,p.ink,'start',1)}
${T(cx,838,(data.score||'—'),58,800,p.ink,'middle',1)}
${T(cx,872,'SCORE FINAL',13,600,p.muted,'middle',4)}
<line x1="${MX}" y1="906" x2="${PW-MX}" y2="906" stroke="${p.line}" stroke-width="1.5"/>
${stats.map((st,i)=> T(cols[i],958,st.val,26,800,p.ink)+T(cols[i],982,(st.lab||'').toUpperCase(),11,600,p.muted,'middle',1)).join('')}
${stats.length?`<line x1="${MX}" y1="1006" x2="${PW-MX}" y2="1006" stroke="${p.line}" stroke-width="1.5"/>`:''}
${T(cx,1036,`${(data.venue||'').toUpperCase()}${data.venue?' · ':''}${s.label.toUpperCase()}`,12,600,p.accent,'middle',2)}
</svg>`;
  }

  window.SNTennis = { render, PALETTES, SURFACES, PW, PH };
})();
